import { gql } from '@apollo/client';

export const pagePurchaseOrders = gql`
  query ($amount: Int!, $field: String!, $page: Int!, $filters: [FilterInput!]) {
    pagePurchaseOrders(grid: { amount: $amount, field: $field, page: $page, filters: $filters }) {
      count
      data {
        id
        submittedBy
        dateRequired
        vendorName
        vendorAddress
        dollarAmount
        location
        agreementNo
        impactedOperatingBudget
        budgetAccountNo
        capitalBudgetAccountNo
        itemBeingPurchased
        renewal
        additionalInfo
        quote
        requestId
        status
        timestamp
        budgetImpactAmount
        supportStaff
        poNumber
        notes
        approver
        forPublicSafety
        requisitionNumber
        dateInitiated
        dateServicesReceived
      }
    }
  }
`;

export const updatePurchaseOrder = gql`
  mutation (
    $id: Float!
    $submittedBy: String!
    $dateRequired: DateTime!
    $vendorName: String!
    $vendorAddress: String!
    $dollarAmount: Float!
    $location: String
    $agreementNo: String
    $impactedOperatingBudget: String
    $budgetAccountNo: String
    $capitalBudgetAccountNo: String
    $itemBeingPurchased: String
    $renewal: Boolean
    $additionalInfo: String
    $quote: String
    $requestId: Int
    $status: String
    $timestamp: DateTime
    $budgetImpactAmount: Float
    $supportStaff: String
    $poNumber: String
    $notes: String
    $approver: String
    $forPublicSafety: Boolean
    $requisitionNumber: String
    $dateInitiated: DateTime
    $dateServicesReceived: DateTime
  ) {
    updatePurchaseOrder(
      input: {
        id: $id
        submittedBy: $submittedBy
        dateRequired: $dateRequired
        vendorName: $vendorName
        vendorAddress: $vendorAddress
        dollarAmount: $dollarAmount
        location: $location
        agreementNo: $agreementNo
        impactedOperatingBudget: $impactedOperatingBudget
        budgetAccountNo: $budgetAccountNo
        capitalBudgetAccountNo: $capitalBudgetAccountNo
        itemBeingPurchased: $itemBeingPurchased
        renewal: $renewal
        additionalInfo: $additionalInfo
        quote: $quote
        requestId: $requestId
        status: $status
        timestamp: $timestamp
        budgetImpactAmount: $budgetImpactAmount
        supportStaff: $supportStaff
        poNumber: $poNumber
        notes: $notes
        approver: $approver
        forPublicSafety: $forPublicSafety
        requisitionNumber: $requisitionNumber
        dateInitiated: $dateInitiated
        dateServicesReceived: $dateServicesReceived
      }
    ) {
      id
      submittedBy
      dateRequired
      vendorName
      vendorAddress
      dollarAmount
      location
      agreementNo
      impactedOperatingBudget
      budgetAccountNo
      capitalBudgetAccountNo
      itemBeingPurchased
      renewal
      additionalInfo
      quote
      requestId
      status
      timestamp
      budgetImpactAmount
      supportStaff
      poNumber
      notes
      approver
      forPublicSafety
      requisitionNumber
      dateInitiated
      dateServicesReceived
    }
  }
`;

export const getPurchaseOrderById = gql`
  query ($id: Int!) {
    getPurchaseOrderById(id: $id) {
      id
      submittedBy
      dateRequired
      vendorName
      vendorAddress
      dollarAmount
      location
      agreementNo
      impactedOperatingBudget
      budgetAccountNo
      capitalBudgetAccountNo
      itemBeingPurchased
      renewal
      additionalInfo
      quote
      requestId
      status
      timestamp
      budgetImpactAmount
      supportStaff
      poNumber
      notes
      approver
      forPublicSafety
      requisitionNumber
      dateInitiated
      dateServicesReceived
    }
  }
`;

export const createAuditMutation = gql`
  mutation createAudit(
    $comment: String
    $createdBy: String
    $createdOn: DateTime
    $lastUpdatedBy: String
    $updatedOn: DateTime
    $entryType: String
    $poId: Float!
  ) {
    createAudit(
      comment: {
        comment: $comment
        createdBy: $createdBy
        createdOn: $createdOn
        lastUpdatedBy: $lastUpdatedBy
        updatedOn: $updatedOn
        entryType: $entryType
        poId: $poId
      }
    ) {
      id
    }
  }
`;
